import { useLayoutEffect, useRef, useState } from "react";

// Este componente se usa para cambiar el tamaño del tracker según el ancho de la pantalla
function TrackerSizer({ baseWidth = 1670, baseHeight = 100, children }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    let rafId = 0;

    const compute = () => {
      const available = el.clientWidth;
      const MIN_SCALE = 0.68;
      const next = Math.max(MIN_SCALE, Math.min(1, available / baseWidth));
      setScale(next);
    };

    compute();

    const ro = new ResizeObserver(() => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(compute);
    });
    ro.observe(el);

    const onWindowResize = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(compute);
    };
    window.addEventListener("resize", onWindowResize);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", onWindowResize);
      cancelAnimationFrame(rafId);
    };
  }, [baseWidth]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        overflow: "hidden",
        height: (baseHeight * (scale + 1)) / 2,
      }}
    >
      <div
        style={{
          width: baseWidth,
          height: baseHeight,
          transform: `scaleX(${scale}) scaleY(${(scale + 1) / 2})`,
          transformOrigin: "left top",
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default TrackerSizer;
